import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=1c1aad5c&scoped=true&"
import script from "./comments.vue?vue&type=script&lang=js&"
export * from "./comments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1aad5c",
  null
  
)

export default component.exports